module.exports = __webpack_public_path__ + "static/loyalty-content-dcd3dc7dd0725bf7cdac9358c0c7edee.png";